import { FC } from "react";
import { Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import __ from "src/utils/Translations";

const CustomDetailPanelToggle: FC = () => (
  <Button
    variant="text"
    startIcon={<ExpandMoreIcon />}
    color="text.primary"
    sx={{ fontWeight: 400 }}
  >
    {__("Szczegóły zmian")}
  </Button>
);

export default CustomDetailPanelToggle;
